import { render, staticRenderFns } from "./PerbaharuiPassword.vue?vue&type=template&id=386b3c1f&scoped=true"
import script from "./PerbaharuiPassword.vue?vue&type=script&lang=js"
export * from "./PerbaharuiPassword.vue?vue&type=script&lang=js"
import style0 from "./PerbaharuiPassword.vue?vue&type=style&index=0&id=386b3c1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386b3c1f",
  null
  
)

export default component.exports